// src/connectors/index.ts
import { Connector } from "@wagmi/connectors";
import { InjectedConnector } from "@wagmi/connectors/injected";
export { Connector, InjectedConnector };